import { defineStore } from "pinia"
import { ref, computed } from "vue"
import { getQuestions, getAudio } from "@/api/s3/index"
import { useHelpStore } from "@/components/af/Help/help.store.js"
import { moveActor } from "@/features/move/machines/moveMachine"
import type { Ref } from "vue"
import type { Question } from "@/features/move/store/move.types"

export const useQuestionsStore = defineStore("moveQuestionsStore", () => {
  const helpStore = useHelpStore()

  const items: Ref<Question[]> = ref([])
  const currentIndex: Ref<number> = ref(0)
  const isLastQuestion: Ref<boolean> = ref(false)

  const currentQuestion = computed<Question>(() => {
    return items.value[currentIndex.value]
  })
  const questionsLength = computed(() => items.value.length)

  async function fetchQuestions() {
    const data = await getQuestions({ test: "move" })
    items.value = data.questions

    return items.value
  }

  function fetchAudios() {
    getAudio({ test: "move" })
  }

  // if current question is not the last one of the list, increment the index
  async function goNext() {
    if (currentIndex.value === items.value.length - 1) {
      isLastQuestion.value = true
      moveActor.send({ type: "done" })
    } else {
      currentIndex.value++
      if (helpStore.isAudioHelpAccepted) {
        helpStore.startAudioSequence()
      }
    }
  }

  function setCurrentIndex(id: number) {
    currentIndex.value = id
  }

  return {
    questions: items.value,
    currentIndex,
    currentQuestion,
    questionsLength,
    fetchQuestions,
    fetchAudios,
    goNext,
    isLastQuestion,
    setCurrentIndex,
  }
})
